<template>
  <div>
    {{now}}
    <br>
    <el-button-group>
      <el-button @click="onClearTasks" type="secondary" size="mini">Clear Tasks</el-button>
      <el-button @click="onClearFinishedTasks" type="secondary" size="mini">Clear Finished Tasks</el-button>
    </el-button-group>
    <br>
    <el-button @click="onInitSession" type="primary" size="mini">Initialize Session</el-button>
    <br>
    <el-button-group>
      <el-button @click="onPauseSession" type="primary" size="mini">Pause Session</el-button>
      <el-button @click="onContinueSession" type="primary" size="mini">Continue Session</el-button>
    </el-button-group>
    <img src="@/assets/sessionmanager.png" />
    <el-button @click="onFinishSession" type="primary" size="mini">Finish Session and Save Points in Daytracker</el-button>
    <el-button @click="onClearDay" type="secondary" size="mini">Clear Day</el-button>
  </div>
</template>

<script>
export default {
  props: {
    now: {
      default: null
    }
  },
  data() {
    return {
      sessionPoints: 0,
    };
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    onClearTasks() {
      console.log("onClearTasks");
    },

    onClearFinishedTasks() {
      console.log("onClearFinishedTasks");
    },

    onInitSession() {
      console.log("onInitSession");
    },

    onPauseSession() {
      console.log("onPauseSession");
    },

    onContinueSession() {
      console.log("onContinueSession");
    },

    onFinishSession() {
      console.log("onFinishSession");
    },

    onClearDay() {
      console.log("onClearDay");
    },
  },
  components: {
  }
};

/*
Sub ClearTasks()
Range("A12", "A28") = ""
Range("B12", "B28") = ""
Range("C12", "C28") = ""
Range("K12", "K28") = ""

End Sub

Sub ClearFinishedTasks()
For u = 0 To 16
    If Range("C12").Offset(u, 0) = 1 Then
        Range("A12").Offset(u, 0) = ""
        Range("B12").Offset(u, 0) = ""
        Range("C12").Offset(u, 0) = ""
        Range("K12").Offset(u, 0) = ""
    End If
Next u

For u = 0 To 16
    If Range("A12").Offset(u, 0) = "" Then
       For I = 1 To 16 - u
            If Range("A12").Offset(u + I, 0) <> "" Then
                Range("A12").Offset(u, 0) = Range("A12").Offset(u + I, 0)
                Range("B12").Offset(u, 0) = Range("B12").Offset(u + I, 0)
                Range("C12").Offset(u, 0) = Range("C12").Offset(u + I, 0)
                Range("A12").Offset(u + I, 0) = ""
                Range("B12").Offset(u + I, 0) = ""
                Range("C12").Offset(u + I, 0) = ""
                Exit For
            End If
       Next I
    End If
Next u

End Sub

Sub ClearDay()
Worksheets("Day").Range("A2", "A1000") = ""
Worksheets("Day").Range("B2", "B1000") = ""
Worksheets("Day").Range("C2", "C1000") = ""
Worksheets("Day").Range("D2", "D1000") = ""
Worksheets("Day").Range("E2", "E1000") = ""
Worksheets("Day").Range("F2", "F1000") = ""
Worksheets("Day").Range("G2", "G1000") = ""
Range("B2") = ""
Range("B3") = ""

TimerActive = False
PauseTimerActive = False

Range("C1") = 0
Range("B7") = 0
End Sub

// -----------------------------------------------------------------------------

Public TimerActive As Boolean
Public EndTime As Double
Public PauseTimerActive As Boolean
Public PauseEndTime As Double
Public BeepCounter As Integer

Public Sub UpdateCountdown()
    If TimerActive Then

        If EndTime < Now Then
          Workbooks("Sessionmanager.xlsm").Worksheets("Session").Range("C1") = 0
          If BeepCounter > 0 Then
            Beep
            BeepCounter = BeepCounter - 1
            'Application.Wait (Now + TimeValue("00:00:01"))
          End If
        Else
          Workbooks("Sessionmanager.xlsm").Worksheets("Session").Range("C1") = EndTime - Now
        End If

        SessionRemainingTime = Workbooks("Sessionmanager.xlsm").Worksheets("Session").Range("C1")
        'Update task Timers
        For u = 1 To 17
            If Workbooks("Sessionmanager.xlsm").Worksheets("Session").Range("B12").Offset(u - 1, 0) <> "" And Workbooks("Sessionmanager.xlsm").Worksheets("Session").Range("C12").Offset(u - 1, 0) <> 1 Then
                sumTimeOtherTasksAfter = 0
                For I = 13 + u - 1 To 28
                    If Workbooks("Sessionmanager.xlsm").Worksheets("Session").Range("C1").Offset(I - 1, 0) <> 1 Then
                        sumTimeOtherTasksAfter = sumTimeOtherTasksAfter + Workbooks("Sessionmanager.xlsm").Worksheets("Session").Range("B1").Offset(I - 1, 0)
                    End If
                Next I

                minutes = sumTimeOtherTasksAfter Mod 60
                hours = (sumTimeOtherTasksAfter - minutes) / 60
                timevalueString = hours & ":" & minutes & ":0"
                Workbooks("Sessionmanager.xlsm").Worksheets("Session").Range("K12").Offset(u - 1, 0) = EndTime - Now - TimeValue(timevalueString)
                If Workbooks("Sessionmanager.xlsm").Worksheets("Session").Range("K12").Offset(u - 1, 0) <= TimeValue("0:0:1") And Workbooks("Sessionmanager.xlsm").Worksheets("Session").Range("K12").Offset(u - 1, 0) >= TimeValue("0:0:0") Then
                    Beep
                End If

            Else
                If Workbooks("Sessionmanager.xlsm").Worksheets("Session").Range("K12").Offset(u - 1, 0) <> "" Then
                    Workbooks("Sessionmanager.xlsm").Worksheets("Session").Range("K12").Offset(u - 1, 0) = ""
                End If
            End If
        Next u

    End If
    alertTime = Now + TimeValue("00:00:01")
    Application.OnTime alertTime, "UpdateCountdown"
End Sub

Public Sub UpdatePauseCountdown()
If PauseTimerActive Then
    If PauseEndTime < Now Then
        Workbooks("Sessionmanager.xlsm").Worksheets("Session").Range("B7") = 0
    Else
        Workbooks("Sessionmanager.xlsm").Worksheets("Session").Range("B7") = PauseEndTime - Now
    End If
    alertTime = Now + TimeValue("00:00:01")
    Application.OnTime alertTime, "UpdatePauseCountdown"
    End If
End Sub

Sub StartSession()

 nextSessionNumber = Worksheets("Day").Range("K2") + 1
 useActionplanSession = 7
 SessionName = ""
 If Worksheets("Actionplan").Range("A1").Offset(nextSessionNumber, 0) <> "" Then
    SessionName = Worksheets("Actionplan").Range("A1").Offset(nextSessionNumber, 0)
    Duration = Worksheets("Actionplan").Range("B1").Offset(nextSessionNumber, 0)
    planningDuration = Worksheets("Actionplan").Range("C1").Offset(nextSessionNumber, 0)
    useActionplanSession = MsgBox("Sessiondaten aus Actionplan übernehmen?" & vbNewLine & "Bezeichnung: " & SessionName & vbNewLine & "Session-Nummer: " & nextSessionNumber & vbNewLine & "Dauer: " & Duration & vbNewLine & "Planungszeit: " & planningDuration, 4)
    If useActionplanSession = 6 And Worksheets("Actionplan").Range("B1").Offset(nextSessionNumber, 0) <> "" And Worksheets("Actionplan").Range("C1").Offset(nextSessionNumber, 0) <> "" Then
        Range("B3") = Worksheets("Actionplan").Range("A1").Offset(nextSessionNumber, 0)
        Range("B4") = Worksheets("Actionplan").Range("B1").Offset(nextSessionNumber, 0)
        Range("B5") = Worksheets("Actionplan").Range("C1").Offset(nextSessionNumber, 0)
        Worksheets("Actionplan").Range("D1").Offset(nextSessionNumber, 0) = 1
    End If
 End If
 If useActionplanSession = 7 Then
    SessionName = InputBox("Bezeichnung der Session eingeben", "Bezeichnung der Session", Range("B3"))
    If SessionName <> vbNullString Then
        Range("B3") = SessionName
    End If

  End If
  If SessionName <> vbNullString Or useActionplanSession = 6 Then

    'Give Flow bonus points if applicable
    If Range("B2") > 1 And Range("B7") > 0 Then ' only if not first session and if pausetimer >0

        flowpoints = 5
        If Range("B2") > 1 Then
            flowpoints = flowpoints + Worksheets("Day").Range("G1").Offset(Range("B2") - 1, 0)
        End If
        MsgBox (flowpoints & " Zusatzpunkte als Flowbonus erhalten")
        Worksheets("Day").Range("G1").Offset(nextSessionNumber - 1, 0) = flowpoints
        Range("B7") = 0
        PauseTimerActive = False
    ElseIf Range("C2") >= 1 Then
        Worksheets("Day").Range("G1").Offset(nextSessionNumber - 1, 0) = 0
     End If

    Range("B3") = SessionName
    Range("B7", "B10") = 0
    Range("B2") = nextSessionNumber
    Range("B8") = 1
     minutes = Range("B4")
     TimerActive = True
     EndTime = Now + TimeSerial(0, minutes, 0)
     Worksheets("Session").Range("C1") = EndTime - Now
     BeepCounter = 3
     UpdateCountdown
   End If
End Sub

Sub PauseSession()
If TimerActive = True Then
 TimerActive = False
 Range("B10") = Range("B10") + 1
 End If
End Sub

Sub ContinueSession()
 TimerActive = True
  TimerActive = True
  EndTime = Now + Range("C1")
End Sub

Sub SavePoints()
If Range("B29") > 0 Then
    TimerActive = False
    Worksheets("Session").Range("C1") = 0
    If Range("B2") = "" & Not (Range("B2") <> Worksheets("Day").Range("K2") + 1 Or Range("B2") <> Worksheets("Day").Range("K2")) Then
    MsgBox "Session initialisieren"
    End If
    If Range("B3") = "" Then
    MsgBox "Bezeichnung der Session eingeben"
    End If
    If Range("B41") > 0 And (Range("B2") <> Worksheets("Day").Range("K2") + 1 Or Range("B2") <> Worksheets("Day").Range("K2")) And Range("B3") <> "" Then
    Worksheets("Day").Range("A1").Offset(Range("B2"), 0) = Range("B2")
    Worksheets("Day").Range("B1").Offset(Range("B2"), 0) = Range("B3")
    Worksheets("Day").Range("C1").Offset(Range("B2"), 0) = Range("B41")
    Worksheets("Day").Range("D1").Offset(Range("B2"), 0) = Range("B4")
    Worksheets("Day").Range("E1").Offset(Range("B2"), 0) = Range("B29")
    Worksheets("Day").Range("F1").Offset(Range("B2"), 0) = Range("D29")
    varRow = Worksheets("Statistics").Range("I2")
    If (Worksheets("Statistics").Range("A1").Offset(varRow, 0) <> DateValue(Now)) Then
    varRow = varRow + 1
    End If

    Worksheets("Statistics").Range("A1").Offset(varRow, 0) = DateValue(Now)
    Worksheets("Statistics").Range("B1").Offset(varRow, 0) = Range("B2") ' session nummer / anzahl sessions
    Worksheets("Statistics").Range("C1").Offset(varRow, 0) = Worksheets("Day").Range("M2") ' Sessiondauer
    Worksheets("Statistics").Range("D1").Offset(varRow, 0) = Worksheets("Day").Range("N2") ' Anzahl Tasks
    Worksheets("Statistics").Range("E1").Offset(varRow, 0) = Worksheets("Day").Range("O2") ' Anzahl Erledigte
    Worksheets("Statistics").Range("F1").Offset(varRow, 0) = Range("B43") ' Gesamtpunkte

    'flowbonus initialisieren
    If Range("B2") > 1 And Worksheets("Actionplan").Range("E1").Offset(Range("B2"), 0) <> "" Then
        pauseTime = Worksheets("Actionplan").Range("E1").Offset(Range("B2"), 0)
    Else
        pauseTime = 3
    End If
    PauseEndTime = Now + TimeSerial(0, pauseTime, 0) ' pause 3 minuten
    PauseTimerActive = True

    alertTime = Now + TimeValue("00:00:01")
    Application.OnTime alertTime, "UpdatePauseCountdown"
    flowpoints = 5
    If Range("B2") > 1 Then
        flowpoints = flowpoints + Worksheets("Day").Range("G1").Offset(Range("B2") - 1, 0)
    End If
    MsgBox Range("B41") & " Session Punkte gespeichert" & vbNewLine & vbNewLine & "Hinweis: Erhalte " & flowpoints & " Bonuspunkte für diese Session" & vbNewLine & "Dazu nächste Session innerhalb von " & pauseTime & " min initialisieren"
    End If
Else
    MsgBox ("Erstmal was arbeiten ;) Tasks eingeben! ")
End If
End Sub

Sub InitializeActionplan()
    Worksheets("Actionplan").Range("F2") = DateValue(Now)

End Sub
*/
</script>
